import { Box } from "@mui/material";
import { hasAnyAccessToResource } from "api/general";
import { useMember } from "api/members";
import "react-loading-skeleton/dist/skeleton.css";
import { useParams } from "react-router-dom";
import { BusinessPerformance } from "./BusinessPerformance";
import { SegmentsAndCustomAttributes } from "./SegmentsAndCustomAttributes";
import { Timeline } from "./Timeline";
import { Wallets } from "./Wallets";

export function GeneralInfo() {
  const { id: memberID } = useParams<{ id: string; page: string }>();
  const { useMembersData } = useMember(memberID);
  const { data: membersData } = useMembersData();

  const hasAnyWalletPermission = hasAnyAccessToResource("WALLET");

  return (
    <>
      <Box mt={8} />
      <SegmentsAndCustomAttributes membersData={membersData} />
      <BusinessPerformance
        averageReturnTransactionAmount={
          membersData?.averageReturnTransactionAmount
        }
        averageTransactionsAmount={membersData?.averageTransactionAmount}
        lastTransactionDate={membersData?.lastTransactionDate}
        returnTransactionsAmount={membersData?.returnTransactionsAmount}
        returnTransactionsCount={membersData?.returnTransactionsCount}
        transactionsAmount={membersData?.transactionsAmount}
        transactionsCount={membersData?.transactionsCount}
      />
      {hasAnyWalletPermission && <Wallets />}
      <Timeline />
    </>
  );
}
